export function getSiteUrl(): string {
  try {
    const envUrl = import.meta.env.VITE_SITE_URL as string | undefined;
    if (envUrl) {
      return envUrl.replace(/\/+$/, '');
    }
  } catch {
    // env not available
  }
  return 'https://mulebuyspreadsheets.lol';
}